import { ArrowDown, ArrowUpRight } from "lucide-react";

const HERO_VIDEO = "/videos/hero.mp4";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full flex flex-col justify-end overflow-hidden bg-cgdark"
    >
      {/* Background video */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-full h-full object-cover opacity-80"
          data-testid="hero-video"
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-cgdark/70 via-cgdark/30 to-cgdark/90" />
      </div>

      {/* Top eyebrow */}
      <div className="absolute top-28 md:top-32 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between text-white/70 text-[11px] font-semibold tracking-[0.25em] uppercase">
          <span className="hidden md:inline">B2B Mobile Wash · Belgium</span>
          <span className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-cgprimary animate-pulse" />
            Actief in heel België
          </span>
        </div>
      </div>

      {/* Main hero content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pb-20 md:pb-28 w-full">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="eyebrow text-cgprimary mb-6" data-testid="hero-eyebrow">
              EST. 2019 · Cargides Group
            </p>
            <h1
              data-testid="hero-headline"
              className="font-heading text-white text-[44px] sm:text-6xl lg:text-[88px] leading-[0.95] font-bold tracking-tight"
            >
              Uw wagenpark, <br />
              <span className="italic font-light">onze</span> zorg. <br />
              <span className="text-cgprimary">Altijd & overal.</span>
            </h1>
          </div>

          <div className="lg:col-span-4 lg:pl-8 lg:border-l lg:border-white/20">
            <p
              className="text-white/85 text-base md:text-lg leading-relaxed mb-8 max-w-md"
              data-testid="hero-subheadline"
            >
              De premium mobiele car- en truckwash voor bedrijven. Wij komen naar
              u toe. Uw vloot blijft representatief, zonder dat u er omkijken
              naar heeft.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#contact" className="cg-btn-primary" data-testid="hero-cta-primary">
                Offerte aanvragen <ArrowUpRight size={16} />
              </a>
              <a href="#diensten" className="cg-btn-secondary" data-testid="hero-cta-secondary">
                Onze diensten
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#stats"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/60 hover:text-white transition-colors flex flex-col items-center gap-2"
        data-testid="hero-scroll-indicator"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ArrowDown size={18} className="animate-bounce" />
      </a>
    </section>
  );
}
